// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{padding:20px;height:100%}.cell{background-color:#f3f3f3;text-align:center;border-radius:7px;padding:16px;align-self:center}", ""]);
// Exports
module.exports = exports;
